import React from "react";
import { ForgotPasswordStep1 } from "./ui/ForgotPasswordStep1";
import { ForgotPasswordStep2 } from "./ui/ForgotPasswordStep2";
import { UI_STYLES } from "@/styles/uiStyles";
import { HeaderBar } from "@/components/ui";
import { useForgotPasswordScreenViewModel } from "./ForgotPasswordScreenViewModel";
import { Helmet } from "react-helmet-async";

enum ForgotPasswordStep {
  Step1 = 1,
  Step2 = 2,
}

export const ForgotPasswordScreen: React.FC = () => {
  const {
    email,
    emailError,
    step,
    resetCode,
    firstPassword,
    secondPassword,
    error,
    setEmail,
    handleSubmitStep1,
    handleSubmitStep2,
    navigateBack,
    handleResetCodeChange,
    handleFirstPasswordChange,
    handleSecondPasswordChange,
    sandNewCode,
    setFirstPasswordVisible,
    setSecondPasswordVisible,
    firstPasswordError,
    secondPasswordError,
    firstPasswordVisible,
    secondPasswordVisible,
    time,
  } = useForgotPasswordScreenViewModel();

  return (
    <div
      className={`
          flex 
          flex-col
           h-full 
           overflow-y-auto 
           w-full
            ${UI_STYLES.backgroundDarkBlue}`}
    >
      <Helmet>
        <title>Восстановление пароля | Мир Звёзд</title>
        <meta name="description" content="Восстановите доступ к своему аккаунту в приложении Мир Звёзд. Безопасное восстановление пароля через email. Вернитесь к своим астрологическим прогнозам и картам Таро." />
        <meta name="keywords" content="восстановление пароля, забыл пароль, сброс пароля, астрология, астрологическое приложение, восстановить доступ, войти в аккаунт" />
        <meta name="author" content="bpTech" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Восстановление пароля | Мир Звёзд" />
        <meta property="og:description" content="Восстановите доступ к своему аккаунту в приложении Мир Звёзд. Безопасное восстановление пароля через email." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://мир-звезд.рф/forgot-password" />
      </Helmet>
      <HeaderBar title="Восстановление пароля" onBack={navigateBack} />
      <div className={`flex flex-col gap-2 w-full max-w-md mx-auto `}>
        {step === ForgotPasswordStep.Step1 && (
          <ForgotPasswordStep1
            onSubmit={handleSubmitStep1}
            email={email}
            setEmail={setEmail}
            emailError={emailError}
          />
        )}
        {step === ForgotPasswordStep.Step2 && (
          <ForgotPasswordStep2
            time={time}
            firstPasswordError={firstPasswordError}
            secondPasswordError={secondPasswordError}
            firstPasswordVisible={firstPasswordVisible}
            secondPasswordVisible={secondPasswordVisible}
            setFirstPasswordVisible={setFirstPasswordVisible}
            setSecondPasswordVisible={setSecondPasswordVisible}
            resetCode={resetCode}
            firstPassword={firstPassword}
            secondPassword={secondPassword}
            error={error}
            onBack={navigateBack}
            onResetCodeChange={handleResetCodeChange}
            onFirstPasswordChange={handleFirstPasswordChange}
            onSecondPasswordChange={handleSecondPasswordChange}
            onSubmit={handleSubmitStep2}
            onSandNewCode={sandNewCode}
          />
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordScreen;
